import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ViewContainerRef, TemplateRef, AfterViewInit, OnDestroy} from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { MessageAddFormComponent } from '@core/components/messages/message-add-form/message-add-form.component';
import { UrlService } from '@core/services/url/url.service';

import { NotificationData } from "@core/store/models/notifications.interface";
import { User } from '@core/objects/user';
@Component({
    selector: 'core-message-add',
    templateUrl: './message-add.component.html',
    styleUrls: ['./message-add.component.scss']
})
export class MessageAddComponent implements OnInit, OnDestroy {
    protected readonly VERSION_SHARE_FEEDBACK_CONTEXT = 'version-share-feedback';
    protected readonly PLUGIN_SHARE_FEEDBACK_CONTEXT = 'plugin-share-feedback';
    protected readonly PLUGIN_SHARE_UPLOAD_VERSION_CONTEXT = 'plugin-share-upload-version';
    protected readonly MESSAGE_SHARE_FEEDBACK_CONTEXT = 'message-share-feedback';

    @ViewChild(MessageAddFormComponent) messageAddForm: MessageAddFormComponent;

    @Input() action: string; // url to add message
    @Input() user: User = null; // user to add in the message notification if it is the case
    @Input() show: boolean = false;
    @Input() showRecord: boolean = false;
    @Input() placeholder: any = '';
    @Input() context: string = 'default'; // this will manage if message form is in app (deafult) or feedback (share)
    @Input() hash: string = ''; // only to use in case of context feedback (share)

    @Output() menuAction = new EventEmitter<string>();
    @Output() onSaved = new EventEmitter<any>();

    public recordNotificationData: NotificationData ;
    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Add Message",
            key: "add-message",
            icon: "add-message"
        }
    ];

    protected menuRecord: ThreeDotsMenuItem = {
        title: "New Record Message",
            key: "add-record",
            icon: "add-record"
    }
    

    public defaultShow: boolean = false;
    public working: boolean = false;
    public error: boolean = false;
    public success: boolean = false;

    protected urlSubscriptor: Subscription;

    constructor(public httpClient: HttpClient,
        private router: Router,
        private urlSrv: UrlService,
        private route: ActivatedRoute) {
    }

    ngOnInit(){
        this.defaultShow = this.show;
        // Control for add new record message menu
        if(this.context == this.VERSION_SHARE_FEEDBACK_CONTEXT || 
            this.context == this.PLUGIN_SHARE_FEEDBACK_CONTEXT ||
            this.context == this.PLUGIN_SHARE_UPLOAD_VERSION_CONTEXT ||
            this.context == this.MESSAGE_SHARE_FEEDBACK_CONTEXT){
            // Add the menu for record message when context is set properly
            this.menu.push(this.menuRecord);

            // data for use in the notification
            this.urlSubscriptor = this.route.params.subscribe((params: any) => {
                if(params.hasOwnProperty('vid')) {
                    this.recordNotificationData = { 
                        id: params.vid, 
                        details: {
                            url: this.router.url, 
                            action: this.action,
                            user: this.user
                        }
                    };
                }
               
            });
        }

    }

    ngOnDestroy() {
        if(this.urlSubscriptor)
            this.urlSubscriptor.unsubscribe();
    }

    renderForm() {
        this.messageAddForm.clean();
    }

    onSubmit(value: any){
        this.working = true;
        this.show = false;
        // update deprecation 
        this.send(value).subscribe({
            next: (data:any) => {
                console.log('Message saved: '+data);
                this.working = false;
                this.setSuccess(true);
                this.onSaved.emit(data);
            },
            error:(error:any) => {
                console.log('Error message: '+error);
                this.working = false;
                this.error = true;
            }
        });
    }

    try() {
        this.error = false;
        this.show = true;
    }

    onMenuClick(key: string) {
        switch(key) {
            case "add-message":
                console.debug(" open add message ", key)
            
                this.show = !this.show;
                break;
            case "add-record":
                console.debug(" open add record ", key)
            
                this.showRecord = !this.showRecord;
                break;
        }

    }


    onRecordStart($event) : void {
        // Hide the modal when press start recording button. Must dismiss the modal during recording.
        this.showRecord = false;
    }
    onRecordCancel($event):void {
        // Hide the modal when press cancel button. User dismiss the recording at all.
        this.showRecord = false;

    }

    onCancel(){
        this.show = false;
    }

    private send(value:any) {
        let options = { headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};

        return this.httpClient.post<string>(this.action, value, options);
    }

    private setSuccess(success: any) {
        this.renderForm();
        this.success = success;
        setTimeout(()=>{
            this.success = false;
            this.show = this.defaultShow;
        }, 1000);
    }

}
